import React, { PureComponent } from 'react';
import { func } from 'prop-types';
import styled from 'styled-components';
import { withCookies } from 'react-cookie';
import { colors } from '../../../../../../../constants/colors';
import NoLimit from './NoLimit';
import LimitMet from './LimitMet';
import InProgress from './InProgress';
import { getAppliedAndMaxTileValues } from '../../../../../../Account/Profile/Insurance/util/insuranceProgress';
import {
  hasNoLimit,
  hasLimitBeenMet,
} from '../../../../../../Account/Profile/Insurance/util/insuranceDetails';
import { safeGet } from '../../../../../../../core/util/object';
import withTileAction from '../../../util/withTileAction';
import { tileBoxShadow } from '../../../../../../../constants/shadows';

const Root = styled.div.withConfig({ componentId: 'sc-96zac9-0' })`
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 8px;
  background-color: ${colors.theWhiteAlbum};
  padding: 20px;
  letter-spacing: 0.2px;
  box-shadow: ${tileBoxShadow};
`;

const ContentContainer = styled.div.withConfig({ componentId: 'sc-96zac9-1' })`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  min-height: 166px;
`;

type Props = {
  cookies: object;
  tile: object;
  tileIndex: number;
  userProfile?: object;
  eventName?: string;
  // @ts-expect-error ts-migrate(2749) FIXME: 'func' refers to a value, but is being used as a t... Remove this comment to see the full error message
  doTileAction?: func;
  insuranceProfile?: object;
  insuranceDetails?: object;
};

class InsuranceProgress extends PureComponent<Props> {
  applied: any;

  limit: any;

  constructor(props: Props) {
    super(props);
    const { tile, insuranceDetails } = this.props;

    this.applied = safeGet(getAppliedAndMaxTileValues(tile, insuranceDetails), '0')('applied');

    this.limit = safeGet(getAppliedAndMaxTileValues(tile, insuranceDetails), '0')('limit');
  }

  getCardContent = () => {
    const { tile } = this.props;

    if (hasNoLimit(this.limit)) return <NoLimit tile={tile} />;

    if (hasLimitBeenMet(this.applied, this.limit))
      return <LimitMet limit={parseInt(this.limit, 10)} tile={tile} />;

    return (
      <InProgress
        applied={parseInt(this.applied, 10)}
        limit={parseInt(this.limit, 10)}
        tile={tile}
      />
    );
  };

  render = () => {
    const { tile, tileIndex, userProfile } = this.props;

    return (
      <Root
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'eventName' does not exist on type 'objec... Remove this comment to see the full error message
        onClick={() => this.props.doTileAction(tileIndex, tile, userProfile, null, tile.eventName)}
      >
        <ContentContainer>{this.getCardContent()}</ContentContainer>
      </Root>
    );
  };
}

// @ts-expect-error ts-migrate(2345) FIXME: Type 'unknown' is not assignable to type 'Function... Remove this comment to see the full error message
export default withCookies(withTileAction(InsuranceProgress));
